import React from "react";
import SelectPaymentMode from "../../../collectPayment/selectPaymentMode/SelectPaymentMode";
import ViewFullBreakup from "../../../collectPayment/selectPaymentMode/viewFullBreakup/ViewFullBreakup";
import CollectedPayments from "../../../collectPayment/selectPaymentMode/collectedPaymentDetails/CollectedPayments";
import { useGetExamChargesContext } from "../../context";
import PaymentModeTopStrip from "../../../collectPayment/alertMessages/PaymentModeTopStrip";
import { useZeroPaidAmountCase } from "../../../collectPayment/context/customHook";
import { fetchAllPostPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../common/constant";

const SelectPaymentModeWrapper = ({ module }) => {
    const {
        setModifyPaymentModeData,
        modifyPaymentModeData,
        setCurrentPaymentMode,
        currentPaymentMode,
        setPaymentModeForm,
        setBankDropdown,
        studentBasicDetails,
        roleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown,
        paymentModeIdLimitList,
        paymentModeFormHandler,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceMode,
        setBalanceAmount,
        loader,
        setloader,
        setCollectPayment,
        balanceAmount,
        collectPayment,
        isOnlineModeEnabled,
        selectedCharges,
        collectVoucherList,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        availablePosList,
        state,
        setState,
        forCentralizedAdmission,
        validatePaymentMode
    } = useGetExamChargesContext();

    const getPaymentModeAndVouchersReqObj = () => {
        const { psid, bu, businessArea, opportunityOwnerId, rollNumber } = studentBasicDetails;
        return {
            psid,
            applicationId: null,
            roleId,
            businessArea: bu ?? businessArea,
            opportunityOwnerId,
            examRollNumber: rollNumber,
            processType: "Exam Payment Collection",
        }
    }

    const getPaymentModesAndVouchers = async() => {
        const url = endpoint.paymentCollection.getVouchersAndPaymentMode;
        const req = getPaymentModeAndVouchersReqObj();
        return fetchAllPostPromisedData(url, req);
    }

    const getFilteredPaymentModes = modes => {
        const selectedChargePaymentMode = selectedCharges['OTHER_CHARGES']?.[0]?.paymentMethod;
        return modes?.filter(mode => mode.toUpperCase() === selectedChargePaymentMode);
    }

    const contextValue = {
        state,
        setState,
        setModifyPaymentModeData,
        modifyPaymentModeData,
        setCurrentPaymentMode,
        setBankDropdown,
        setPaymentModeForm,
        studentBasicDetails,
        roleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown,
        paymentModeIdLimitList,
        paymentModeFormHandler,
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceMode,
        setBalanceAmount,
        loader,
        setloader,
        setCollectPayment,
        balanceAmount,
        collectPayment,
        isOnlineModeEnabled,
        selectedCharges,
        collectVoucherList,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        availablePosList,
        forCentralizedAdmission,
        validatePaymentMode,
        // getPaymentModeAndVouchersReqObj,
        getPaymentModesAndVouchers
        // getFilteredPaymentModes
    };

    useZeroPaidAmountCase(
        selectedCharges,
        balanceAmount,
        setCollectPayment,
        collectPayment
    );

    return (
        <>
            <PaymentModeTopStrip module={module} />
            <div className="d-flex mt-2" style={{ columnGap: "10px" }}>
                <SelectPaymentMode contextValue={contextValue} module={module} />
                <div style={{ width: "33%" }}>
                    <ViewFullBreakup module={module} />
                    <CollectedPayments contextValue={contextValue} module={module} />
                </div>
            </div>
        </>
    );
};

export default SelectPaymentModeWrapper;
